export const initState = {
  transactions: [],
  isLoaded: false,
  isEmpty: false,
}
